import { DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR, DEFAULT_TIME_FORMAT } from 'core/constants';
import { SubmissionVersionType } from 'utils/api/modules/entities/entities.types';
import { formatMoment, readerDayKey } from 'utils/formatters/timezone';

const DATE_FORMAT = DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR;

export const formatWindow = (entry: Pick<SubmissionVersionType, 'currentFrom' | 'supersededAt'>): string => {
  const from = formatMoment(entry.currentFrom, DATE_FORMAT);
  if (!entry.supersededAt) return `Since ${from}`;

  const sameDay = readerDayKey(entry.currentFrom) === readerDayKey(entry.supersededAt);
  return `${from} to ${formatMoment(entry.supersededAt, sameDay ? DEFAULT_TIME_FORMAT : DATE_FORMAT)}`;
};

export const describeSource = (
  entry: Pick<SubmissionVersionType, 'attribution' | 'source' | 'changedBy' | 'isFirst'>
): string => {
  const verb = entry.isFirst ? 'Received from' : 'Amended by';
  if (entry.attribution === 'partner' && entry.source) return `${verb} ${entry.source}`;
  if (entry.attribution === 'user' && entry.changedBy) return `${verb} ${entry.changedBy.name}`;
  return 'Source no longer available';
};
